<template>
  <div class="proj-bid-new-nav-step">
    <EbHeader>
      <template slot="middle">
        <EbNavStep :navArr="navArr" :disabled="!projectId ? true : false" @beforeRouteChange="beforeRouteChange"></EbNavStep>
      </template>
    </EbHeader>
  </div>
</template>

<script>
import EbHeader from '@/components/common/eb-header';
import EbNavStep from '@/components/common/eb-nav-step';
import { calcNavArr } from '@/services/proj/project-service';

export default {
  components: {
    EbHeader,
    EbNavStep
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      navArr: [
        {
          routePath: '/projpro/new/info',
          params: '/{projectId}',
          initImgSrc: '/static/img/yi3.jpg',
          activeImgSrc: '/static/img/yi2.jpg',
          finishImgSrc: '/static/img/yi1.jpg',
          title: '项目信息'
        },
        {
          routePath: '/projpro/new/ruleedit',
          params: '/{projectId}',
          initImgSrc: '/static/img/yi3.jpg',
          activeImgSrc: '/static/img/yi2.jpg',
          finishImgSrc: '/static/img/yi1.jpg',
          title: '采购规则'
        },
        {
          routePath: '/projpro/new/purchaselist',
          params: '/{projectId}',
          initImgSrc: '/static/img/yi3.jpg',
          activeImgSrc: '/static/img/yi2.jpg',
          finishImgSrc: '/static/img/yi1.jpg',
          title: '采购清单'
        },
        {
          routePath: '/projpro/new/invitesupplier',
          params: '/{projectId}',
          initImgSrc: '/static/img/yi3.jpg',
          activeImgSrc: '/static/img/yi2.jpg',
          finishImgSrc: '/static/img/yi1.jpg',
          title: '邀请供应商'
        },
        {
          routePath: '/projpro/new/preview',
          params: '/{projectId}',
          initImgSrc: '/static/img/yi3.jpg',
          activeImgSrc: '/static/img/yi2.jpg',
          finishImgSrc: '/static/img/yi1.jpg',
          title: '预览发布'
        }
      ]
    };
  },
  created() {
    // 设置参数
    calcNavArr(this.navArr, { projectId: this.projectId });
    // console.log(this.navArr, 'this.navArr');
  },
  methods: {
    beforeRouteChange(params) {
      this.$emit('beforeRouteChange', {
        success() {
          params.success();
        },
        error() {
          params.error();
        }
      });
    }
  }
};
</script>

<style lang="less">

</style>
